import { Tabs, Tab, Skeleton, Typography, Grid2, Card, Stack } from "@mui/material";
import { Fragment, useContext } from "react";
import { AppContext } from "../context/AppContext";
import { ReportConfiguration } from "../interfaces/AppDefinitions";
import propertyIcon from "../assets/img/house_w_garage.png";
export default function PropertyScroller() {
	const { appState, appDispatch } = useContext(AppContext);

	function handleChange(event: React.SyntheticEvent, addrId: number) {
		appDispatch({ type: "SET_CURRENT_ADDR_ID", value: addrId });
	}

	function PropertyCard(config: ReportConfiguration) {
		const isViewing = config.addrId === appState.currentAddrId;

		return (
			<Card
				className="fullwidth-container"
				elevation={isViewing ? 3 : 1}
				sx={{ border: "1px solid #E1E4EA", backgroundColor: appState.colorPallete["scheme2"] }}
			>
				<Grid2 container minWidth={270}>
					<Grid2 size={4} sx={{ textAlign: "center", alignContent: "center" }}>
						<div style={{ position: "relative", width: "88px", height: "52px", borderRadius: "10px" }}>
							<img style={{ width: "88px", height: "52px" }} src={propertyIcon} alt="property-icon" />
							<div
								style={{
									backgroundColor: appState.colorPallete["scheme2"],
									width: "88px",
									height: "80px",
									position: "absolute",
									top: -10,
									left: 0,
									opacity: 0.4,
									borderRadius: "5px",
								}}
							></div>
						</div>
					</Grid2>
					<Grid2 size={8} sx={{ textAlign: "center", alignContent: "center" }}>
						<Stack sx={{ textAlign: "center", textTransform: "capitalize" }}>
							<Typography variant="caption" sx={{ fontSize: "18px", lineHeight: "24px" }}>
								{isViewing ? <b>{config.city}</b> : config.city}
							</Typography>
							<Typography variant="caption" sx={{ fontSize: "14px", lineHeight: "24px" }}>
								{config.street}
							</Typography>
							<Typography variant="caption" sx={{ fontSize: "14px", lineHeight: "24px" }}>
								{config.state}
							</Typography>
						</Stack>
					</Grid2>
				</Grid2>
			</Card>
		);
	}

	if (appState.currentAddrId === undefined) {
		return <Skeleton width="100%" height={180} />;
	}

	return (
		<Fragment>
			<Tabs
				value={appState.currentAddrId}
				onChange={handleChange}
				variant="scrollable"
				scrollButtons={false}
				allowScrollButtonsMobile={true}
			>
				{appState.report_configuration?.map((config: ReportConfiguration, idx) => (
					<Tab
						key={idx}
						value={config.addrId}
						label={PropertyCard(config)}
						sx={{ padding: 0.1, margin: 0.5 }}
					/>
				))}
			</Tabs>
		</Fragment>
	);
}
